import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/logo-tenshoku-2.gif'


const _withScopeId = n => (_pushScopeId("data-v-5a5ad442"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-jobsearch-list_item_check"
}
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "p-jobsearch-card" }
const _hoisted_4 = { class: "p-jobsearch-card_inner" }
const _hoisted_5 = { class: "p-jobsearch-card_header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "p-jobsearch-tag01" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "p-jobsearch-tag01_item __public" }, "公開求人から検索")
], -1))
const _hoisted_7 = { class: "p-jobsearch-heading word_break" }
const _hoisted_8 = { class: "p-jobsearch-company" }
const _hoisted_9 = { class: "p-jobsearch-tit" }
const _hoisted_10 = { class: "p-jobsearch-tag02" }
const _hoisted_11 = {
  key: 0,
  class: "p-jobsearch-tag02_item __blank"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "p-jobsearch-outline" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "__income" }, "年収", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "__place" }, "勤務地", -1))
const _hoisted_17 = { class: "word_break" }
const _hoisted_18 = { class: "__job" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "__job" }, "仕事内容", -1))
const _hoisted_20 = { class: "__job scrollable" }
const _hoisted_21 = {
  key: 0,
  class: "p-jobsearch-buttons"
}
const _hoisted_22 = {
  key: 1,
  class: "p-jobsearch-btn __applied"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1))
const _hoisted_24 = {
  key: 2,
  class: "p-jobsearch-heart js-heart __animation"
}
const _hoisted_25 = ["checked"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_icon" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_txt" }, "気になる", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-heart_bubble" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_29 = {
  key: 1,
  class: "p-jobsearch-buttons-search-public"
}
const _hoisted_30 = { class: "p-jobsearch-detail-wrapper" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-btn_ico" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-logo" }, [
    /*#__PURE__*/_createTextVNode(" 提供元 : "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "マイナビ転職"
    })
  ])
], -1))

import { watch } from 'vue';

import { JobSearchPublicCard } from '@/types';

import { onMounted } from 'vue';
import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'JobSearchPublicListItem',
  props: {
    job: null,
    isBulkSelectionEnabled: { type: Boolean },
    isHiddenHeart: { type: Boolean },
    screenName: null,
    isAfterApply: { type: Boolean }
  },
  emits: [
  'update:checked',
  'update:favorite',
  'save-scroll-top'
],
  setup(__props: any, { emit }) {

const props = __props as {
  job: JobSearchPublicCard;
  isBulkSelectionEnabled: boolean;
  isHiddenHeart?: boolean;
  screenName: string;
  isAfterApply?: boolean;
}


const favoriteIcon = ref<HTMLInputElement | null>();



const handleCheckboxChange = (event: Event) => {
  emit('update:checked', (event.target as HTMLInputElement).checked);
};

const handleFavoriteChange = (event: boolean | undefined) => {
  updateJobLikedStatus();
  emit('update:favorite', event);
};

const handleClickDetail = () => {
  emit('save-scroll-top');
};

/**
 * Updates the isLiked property of the job detail if its value differs from the provided checked state.
 * @param checked - The new liked state to set.
 */
const updateJobLikedStatus = () => {
  if (favoriteIcon.value) {
    favoriteIcon.value.checked = props.job.isLiked ?? false;
  }
};

/**
 * Watching the Job changes to updates the isLiked property of the job detail if its value differs from the provided checked state.
 */
watch(() => props.job, () => {
  updateJobLikedStatus();
});


// src/js/_module/_tooltip.ts
function initializeTooltips() {
  const tooltipOpenButtons = document.querySelectorAll('.js-tooltip-open-button');
  tooltipOpenButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tooltipContainer = button.querySelector('.js-tooltip-container');
      if (tooltipContainer) {
        document.querySelectorAll('.js-tooltip-container.is-active').forEach((openTooltip) => {
          if (openTooltip !== tooltipContainer) {
            openTooltip.classList.remove('is-active');
          }
        });
        tooltipContainer.classList.add('is-active');
      }
    });
  });
  const tooltipCloseTriggers = document.querySelectorAll('.js-tooltip-close-trigger');
  tooltipCloseTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const tooltipContainer = trigger.closest('.js-tooltip-container');
      if (tooltipContainer) {
        tooltipContainer.classList.remove('is-active');
      }
    });
  });
      document.addEventListener('click', (event) => {
    const openTooltips = document.querySelectorAll('.js-tooltip-container.is-active');
    openTooltips.forEach((tooltip) => {
      const openButton = tooltip.parentElement;
      if (openButton && !openButton.contains(event.target) && !tooltip.contains(event.target)) {
        tooltip.classList.remove('is-active');
      }
    });
  });
}
onMounted(() => {
  initializeTooltips();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-jobsearch-list_item", {closed: __props.job.isFavorite}])
  }, [
    (__props.isBulkSelectionEnabled)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createElementVNode("input", {
            class: "js-check-jobitem",
            type: "checkbox",
            checked: __props.job.checked,
            onChange: handleCheckboxChange
          }, null, 40, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(__props.job.companyName), 1),
            _createElementVNode("h2", _hoisted_9, [
              (!__props.job.isBooster)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: `/jobsearch/detail/${__props.job.orderId}/public`,
                    onClick: handleClickDetail
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.job.jobTitle), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: `/jobsearch/detail/${__props.job.orderId}/booster`,
                    onClick: handleClickDetail
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.job.jobTitle), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
            ])
          ]),
          _createElementVNode("ul", _hoisted_10, [
            (__props.job.pickupLink && !__props.job.isBooster)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _createElementVNode("a", {
                    href: __props.job.pickupLink || '#',
                    target: "_blank"
                  }, "PICK UP", 8, _hoisted_12)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", null, [
            (__props.job.orderId)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "求人ID：" + _toDisplayString(__props.job.orderId), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("dl", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("dd", null, _toDisplayString(__props.job.annualIncome), 1),
          _hoisted_16,
          _createElementVNode("dd", _hoisted_17, _toDisplayString(__props.job.workLocation), 1),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("dd", _hoisted_20, _toDisplayString(__props.job.jobDescription), 1)
          ])
        ]),
        (!__props.job.isBooster)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (!__props.isAfterApply)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "p-jobsearch-btn __blue",
                    to: `/apply/form/${__props.job.orderId}/${props.screenName}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 応募する ")
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, "応募済み")),
              _createVNode(_component_router_link, {
                class: _normalizeClass([{
              'p-jobsearch-btn __white __link': __props.isHiddenHeart == false,
              'p-jobsearch-btn __whiteNoHeart __link': __props.isHiddenHeart == true,
            }, "p-jobsearch-btn __white __link"]),
                to: `/jobsearch/detail/${__props.job.orderId}/public`,
                onClick: handleClickDetail
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 詳細を見る "),
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["class", "to"]),
              (__props.isHiddenHeart == false)
                ? (_openBlock(), _createElementBlock("label", _hoisted_24, [
                    _createElementVNode("input", {
                      ref_key: "favoriteIcon",
                      ref: favoriteIcon,
                      type: "checkbox",
                      checked: __props.job.isLiked,
                      onChange: _cache[0] || (_cache[0] = ($event: any) => (handleFavoriteChange(!__props.job.isLiked)))
                    }, null, 40, _hoisted_25),
                    _hoisted_26,
                    _hoisted_27,
                    _hoisted_28
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_router_link, {
                  class: "p-jobsearch-btn __white __link __detail-full",
                  to: `/jobsearch/detail/${__props.job.orderId}/booster`,
                  onClick: handleClickDetail
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 詳細を見る "),
                    _hoisted_31
                  ]),
                  _: 1
                }, 8, ["to"]),
                _hoisted_32
              ])
            ]))
      ])
    ])
  ], 2))
}
}

})